export const delay = 2000
